const TYPES = {
    JOURNAL_ADD_FIELD: 'journalAddField',
    JOURNAL_ADD_COLUMN: 'journalAddColumn',
    JOURNAL_DOWNLOAD_EXCEL: 'journalDownloadExcel',
    JOURNAL_DOWNLOAD_SETTINGS: 'journalDownloadSettings',
    JOURNAL_BUTTONS_GRADES_COURSE: 'journalButtonsGradesCourse',
    JOURNAL_TEST_ANALYTICS_SETTINGS: 'journalTestAnalyticsSettings',
    JOURNAL_ADD_FIELD_FINAL_ANALYTICS: 'journalAddFieldFinalAnalytics',
    JOURNAL_LESSON_TYPE_INFO: 'journalLessonTypeInfo',
    JOURNAL_AUTO_FILL_ADDITIONAL_FIELD: 'journalAutoFillAdditionalField',
    CONFIRMATION: 'confirmation',
    UPLOADING_FILES_TO_MEDIA_PLATFORMS: 'uploadingFilesToMediaPlatforms',
    EDIT_DIRECTION_COPY: 'editDirectionCopy',
    TIPTAP_RESIZE_IMAGE: 'tiptapResizeImage',
    DEPARTMENTS_SELECT: 'departmentsSelect',
    SELECT_FILES_FROM_MEDIA_PLATFORM: 'selectFilesFromMediaPlatform',
    CHANGE_DEADLINE: 'changeDeadline',
    CREATE_WELCOME_MESSAGE: 'createWelcomeMessage',
    DELAYED_MESSAGE: 'delayedMessage',
    CHAT_FOLDERS: 'chatFolders',
    PLATF_SETTINGS_ADDITIONAL_COLUMN: 'platfSettingsAdditionalColumn',
    LIST_OF_PERSONAL_ACCOUNTS: 'listOfPersonalAccounts',
    MANUALS_MODAL: 'manualsModal',
    REPORTS_VISIBILITY: 'reportsVisibility',
    TIMETABLE_AUDIENCE_FORM: 'timetableAudienceForm',
    TIMETABLE_AUDIENCE_REPLACE: 'timetableAudienceReplace',
    VIEW_IMAGE: 'viewImage',
    AI_TASK_GENERATOR: 'aiTaskGenerator',
    AI_COURSE_STRUCTURE_GENERATOR: 'aiCourseStructureGenerator',
    SELECTION_COURSE_BLOCKS: 'selectionCourseBlocks',
    ACTIVITY_ANALYTICS_SETTINGS: 'activityAnalyticsSettings',
    REQUIRED_DOCUMENTS_COMPLIANCE: 'requiredDocumentsCompliance', // REQUIRED_DOCUMENTS_FEATURE_DISABLED
    GROUP_GRADING_SYSTEM: 'groupGradingSystem',
    SELECT_GRADING_SYSTEM: 'selectGradingSystem',
}
export default TYPES
